import type { ReactNode } from 'react';
import styles from './Modal.module.css';

interface Props {
  title: string;
  eyebrow?: string;
  children: ReactNode;
  onClose(): void;
  wide?: boolean;
}

/** Janela sobre a tela, no mesmo visual dos pedidos de conexão. */
export function Modal({ title, eyebrow, children, onClose, wide }: Props) {
  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true" aria-label={title} onMouseDown={onClose}>
      <div className={`${styles.dialog} ${wide ? styles.wide : ''}`} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.head}>
          <div>
            {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
            <h2 className={styles.title}>{title}</h2>
          </div>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
